import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=3f4fbad2&scoped=true&"
import script from "./UploadFile.vue?vue&type=script&lang=ts&"
export * from "./UploadFile.vue?vue&type=script&lang=ts&"
import style0 from "./UploadFile.vue?vue&type=style&index=0&id=3f4fbad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4fbad2",
  null
  
)

export default component.exports